































import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class TemplateNoMenu extends Vue {
  @Prop({ default: false }) private noAlign!: boolean
  @Prop() private classes!: string

  get logo() {
    return process.env.VUE_APP_LOGO_LOGIN
  }
}
